module.exports = __webpack_public_path__ + "img/choose_building-mobile.0fbd51ff.jpg";